module.exports = __webpack_public_path__ + "static/media/mk.8f27127c.svg";